import { alpha, height, maxHeight, maxWidth } from "@mui/system";

const styles = (theme) => ({
	containerComponent: {
		width: "100%",
		top: 16,
		display: "flex",
		justifyContent: "center",
		position: "sticky",
		zIndex: 999,
		flexDirection: "column",
		overflow: "visible",
	},
	containerPaper: {
		width: "calc(100% + 32px)",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		borderRadius: 0,
		backgroundColor: alpha(theme.palette.background.paper, 0.8),
		backdropFilter: "blur(6px)",
		gap: 2,
		paddingX: 1.75,
		height: "68.5px",
		position: "relative",
		transform: "translateX(-16px) translateY(-16px)",
		// top: -16,
		// left: -16,
	},
	conatinerSpeedDial: {
		position: "fixed",
		bottom: 16,
		right: 16,
		zIndex: 1300,
		transform: "translateZ(0px)",
		minHeight: 100,
	},
	containerFilter: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
	},

	containerToGoBack: {
		width: "100%",
		display: "flex",
		padding: 1,
	},

	containerDrawer: {
		minWidth: "350px",
		maxWidth: "400px",
		display: "flex",
		flexDirection: "column",
	},
	boxDrawer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		mt: 2,
	},
	boxDrawerType1: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		mt: 2,
		ml: "55px",
	},
	boxFilters: { display: "flex", flexDirection: "column", gap: 1, p: 2 },
});

export default styles;
